const newsletterForm = document.getElementById('mailchimp');
const formMessage = document.getElementById('formMessage');
const formError = document.getElementById('formError');

if (newsletterForm) {
    newsletterForm.onsubmit = async (e) => {
        e.preventDefault()
        const formData = new FormData(newsletterForm)

        try {
            const response = await fetch('/mailchimp/send', {
                method: 'post',
                body: formData
            })

            newsletterForm.querySelector('.newsletter-form-full__button').disabled = true;

            const result = await response.json()

            const { success, msg } = result

            if (success) {
                formMessage.style.display = 'block';
            }

            if (!success) {
                formError.querySelector('span').textContent = msg;
                formError.style.display = 'block';
                newsletterForm.querySelector('.newsletter-form-full__button').disabled = false
            }
        } catch (error) {
            console.error(error)
            
            formError.querySelector('span').textContent = error;
            formError.style.display = 'block';
            newsletterForm.querySelector('.newsletter-form-full__button').disabled = false
        }
    }
}
